var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"box"},[_c('h1',[_vm._v("404!")]),_c('p',[_vm._v("没有权限，页面丢失了~")]),_c('el-button',{attrs:{"type":"danger","size":"mini"},on:{"click":_vm.backToLogin}},[_vm._v("返回登录页面")])],1),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('span',[_c('i',{staticClass:"el-icon-question"})])])
}]

export { render, staticRenderFns }